import { createContext, useContext } from "react";

interface PatientPageHeaderContextValue {
  headerEl: HTMLElement | null;
}

export const PatientPageHeaderContext =
  createContext<PatientPageHeaderContextValue>({
    headerEl: null,
  });

export const usePatientPageHeader = () => useContext(PatientPageHeaderContext);
